module.exports = __webpack_public_path__ + "img/9788952751119.9abc02f6.jpg";